import { Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useNumberParams from '../../../../hooks/useNumberParams';
import CasinoBtnSave from '../../../../components/casino/CasinoBtnSave';
import { useTranslation } from 'react-i18next';
import CusCheckbox from '../../../../components/material-ui/CusCheckbox';
import TypographyText from '../../../../components/material-ui/table/TypographyText';
import CustomTextField from '../../../../components/forms/theme-elements/CustomTextField';
import { API_CASINO } from '../../../../api/casino';
import useToast from '../../../../hooks/useToast';
import useColor from '../../../../hooks/site/useColor';
import CusTooltip from '../../../../components/material-ui/CusTooltip';
import CusItemTooltip from '../../../../components/material-ui/CusItemTooltip';
import CaptchaKeys from './CaptchaKeys';

export default function CaptchaSettingContent() {
  const { t } = useTranslation();
  const casinoId = useNumberParams('casinoId');
  const { successToast } = useToast();
  const { grey } = useColor();

  const [captchaInfo, setCaptchaInfo] = useState({});
  const [captchaKeys, setCaptchaKeys] = useState(null);

  const captchaStruct = [
    { id: 'userReg', label: 'when registering a new user on site' },
    { id: 'userAuth', label: 'When a user logs in to the website' },
    { id: 'getFiatOnSite', label: 'when receiving fiat details on the website' },
    { id: 'getCryptoOnSite', label: 'when receiving crypto details on the website' }
    // { id: 'getFiatOnBot', label: 'when receiving fiat details in the bot' }
  ];

  const onSaveClick = ({ captchaInfoKeys }) => {
    const info = { ...captchaInfo };
    delete info.captcha;

    API_CASINO.captcha
      .set({ casinoId, data: info })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  useEffect(() => {
    API_CASINO.captcha
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data;
        setCaptchaInfo(data);
        setCaptchaKeys(data.captcha || null);
      })
      .catch(console.error);
  }, [casinoId]);

  const MiniInput = ({ value, setValue }) => (
    <CustomTextField
      type="number"
      sx={{ width: 70, mx: 1 }}
      value={value}
      autoComplete="off"
      onChange={(e) => setValue(e.target.value)}
      slotProps={{
        htmlInput: { min: 1, sx: { py: 0.25 } },
        input: { sx: { borderRadius: 1 } }
      }}
    />
  );

  const depositCount =
    captchaInfo.getFiatOnBot?.enabled && (captchaInfo.getFiatOnBot?.skipIfDeposit?.count || 1);

  return (
    <Stack gap={5}>
      <CaptchaKeys casinoId={casinoId} info={captchaInfo.captcha} />

      <Stack gap={2}>
        <Stack gap={1}>
          <Typography>{t('Show captcha when')}:</Typography>
          <Stack>
            {captchaStruct.map((el) => {
              const value = captchaInfo[el.id]?.enabled || '';

              return (
                <CusCheckbox
                  key={'captcha_' + el.id}
                  label={el.label}
                  checked={value}
                  onChange={() =>
                    setCaptchaInfo((prev) => {
                      const prevInfo = JSON.parse(JSON.stringify(prev));
                      if (!prevInfo[el.id]) prevInfo[el.id] = {};
                      prevInfo[el.id].enabled = !value;
                      return prevInfo;
                    })
                  }
                />
              );
            })}
          </Stack>

          <Stack sx={{ background: grey[100], p: 1, borderRadius: 1 }}>
            <CusCheckbox
              key={'captcha_getFiatOnBot'}
              label={'when receiving fiat details in the bot'}
              checked={captchaInfo.getFiatOnBot?.enabled}
              onChange={() =>
                setCaptchaInfo((prev) => {
                  const prevInfo = JSON.parse(JSON.stringify(prev));
                  console.log('prevInfo', prevInfo);

                  if (!prevInfo.getFiatOnBot) prevInfo.getFiatOnBot = {};
                  prevInfo.getFiatOnBot.enabled = !prevInfo.getFiatOnBot.enabled;

                  if (prevInfo.getFiatOnBot.enabled && !prevInfo.getFiatOnBot.skipIfDeposit.count) {
                    prevInfo.getFiatOnBot.skipIfDeposit.count = 1;
                  }

                  if (!prevInfo.getFiatOnBot.enabled) {
                    prevInfo.getFiatOnBot.skipIfDeposit.count = null;
                    prevInfo.getFiatOnBot.skipIfDeposit.days = null;
                  }
                  return prevInfo;
                })
              }
            />

            <Box component={'span'}>
              <TypographyText>{t("Don't show captcha if the player did")}</TypographyText>{' '}
              <MiniInput
                value={depositCount}
                setValue={(val) =>
                  setCaptchaInfo((prev) => {
                    const prevInfo = JSON.parse(JSON.stringify(prev));
                    if (!prevInfo.getFiatOnBot) prevInfo.getFiatOnBot = {};
                    if (!prevInfo.getFiatOnBot.skipIfDeposit)
                      prevInfo.getFiatOnBot.skipIfDeposit = {};

                    const countDay = val ? +val : 1;
                    prevInfo.getFiatOnBot.skipIfDeposit.count = countDay;
                    return prevInfo;
                  })
                }
              />{' '}
              <TypographyText>{t('successful deposits over the past')}</TypographyText>{' '}
              <MiniInput
                value={captchaInfo.getFiatOnBot?.skipIfDeposit?.days}
                setValue={(val) =>
                  setCaptchaInfo((prev) => {
                    const prevInfo = JSON.parse(JSON.stringify(prev));
                    if (!prevInfo.getFiatOnBot) prevInfo.getFiatOnBot = {};
                    if (!prevInfo.getFiatOnBot.skipIfDeposit)
                      prevInfo.getFiatOnBot.skipIfDeposit = {};

                    const lastDays = val ? +val : null;
                    prevInfo.getFiatOnBot.skipIfDeposit.days = lastDays;
                    return prevInfo;
                  })
                }
              />{' '}
              <TypographyText>
                <TypographyText>{t('day(s)')} </TypographyText>
                <span style={{ display: 'inline-block', height: '15px' }}>
                  <CusItemTooltip
                    text={
                      'If the number of days is not specified, the number of deposits made for the entire period is checked.'
                    }
                  />
                </span>
              </TypographyText>
            </Box>
          </Stack>
        </Stack>

        <CasinoBtnSave onClick={() => onSaveClick({})} />
      </Stack>
    </Stack>
  );
}
